import { paths } from '@/routes/paths'
import { useIsInPath, useStateObject } from '@/utils'
import { createContext, useContext, useEffect, ReactNode } from 'react'
import { useLocation, useParams } from 'react-router-dom'

interface AccessContextType {
  locationId?: string
}

interface AccessProviderProps {
  children: ReactNode
}

const accessContext = createContext<AccessContextType>({})

export const AccessProvider = ({ children }: AccessProviderProps) => {
  const { pathname } = useLocation()
  const { locationId } = useParams<{ locationId: string }>()
  const [access, dispatchAccess] = useStateObject<AccessContextType>({})

  const isInDashboard = useIsInPath(paths.dashboard)

  useEffect(() => {
    if (isInDashboard && access.locationId) {
      dispatchAccess({ locationId: '' })
    } else if (pathname.includes('/location/view')) {
      dispatchAccess({ locationId })
    } else if (locationId && !access.locationId) {
      dispatchAccess({ locationId })
    }
  }, [pathname, locationId, access.locationId])

  return (
    <accessContext.Provider value={access}>{children}</accessContext.Provider>
  )
}

export const useAccessContext = () => useContext(accessContext)
